import { useMemo } from 'react';

import configService, { getConfigString } from '@lib/services/configService';

import useSitePatient from './useSitePatient';

function parseEnvVarString(value?: string) {
  return `${value}`.trim();
}

function parseEnvVarArray(value?: string) {
  return `${value}`.split(',').map((v) => v.trim());
}

function parseEnvVarInt(value?: string) {
  return parseInt(`${value}`, 10);
}

const parseEnvJSON = (value?: string, defaultValue?: any) => {
  try {
    return JSON.parse(value || JSON.stringify(defaultValue));
  } catch (error) {
    return defaultValue;
  }
};

export default function useModulesProviderConfig() {
  const sitePatient = useSitePatient();

  const config = useMemo(
    () => ({
      podName: parseEnvVarString(configService.getPodName()),
      api: {
        base: parseEnvVarString(configService.getApiBasePath()),
        graphql: parseEnvVarString(configService.getApiGraphQLPath()),
        socket: parseEnvVarString(configService.getApiSocketPath()),
      },
      broadcast: {
        invalidTerms: parseEnvVarArray(configService.getBroadcastInvalidTerms()),
        offensiveWords: parseEnvVarArray(configService.getBroadcastOffensiveWords()),
      },
      datadog: {
        applicationId: parseEnvVarString(configService.getDatadogApplicationId()),
        clientToken: parseEnvVarString(configService.getDatadogClientToken()),
      },
      files: {
        accept: parseEnvVarArray(configService.getFilesAccept()),
      },
      fullstory: {
        id: parseEnvVarString(configService.getFullstoryId()),
      },
      googl: {
        key_maps: parseEnvVarString(configService.getGooglKeyMaps()),
      },
      gtm: {
        id: parseEnvVarString(configService.getGtmId()),
      },
      recaptcha: {
        id: parseEnvVarString(configService.getRecaptchaId()),
      },
      site: {
        next: parseEnvVarString(configService.getSiteNext()),
        patient: sitePatient,
        widgets: parseEnvVarString(configService.getSiteWidgets()),
        sso: parseEnvVarString(configService.getSiteSso()),
        nextyModules: getConfigString('REACT_APP_SITE_NEXTY_MODULES'),
        nextyNext: getConfigString('REACT_APP_SITE_NEXTY_NEXT'),
        nextyPatient: getConfigString('REACT_APP_SITE_NEXTY_PATIENT'),
      },
      web: {
        passwordMinimumLength: parseEnvVarInt(configService.getWebPasswordMinimumLength()),
      },
      resellerPartners: parseEnvJSON(configService.getResellerPartners(), []),
    }),
    [sitePatient],
  );

  return config;
}
